export default __webpack_public_path__ + "static/media/icon-rouded.66b29457.png";